import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import "core-js/modules/es.number.constructor.js";
import isPlainObject from "lodash/isPlainObject";
import { defineComponent as _defineComponent } from 'vue';
import { addUnit } from '@/shared/util';
import '@/assets/symbol/icon-symbols';
var __default__ = {
    name: 'XSvgIcon'
};
export default /*#__PURE__*/ _defineComponent(_object_spread_props(_object_spread({}, __default__), {
    props: {
        name: String,
        size: [
            Number,
            String,
            Object,
            Array
        ],
        dot: Boolean,
        badge: [
            Number,
            String
        ]
    },
    emits: [
        "click"
    ],
    setup: function(__props, param) {
        var emit = param.emit;
        var props = __props;
        var getSizeByKey = function(key) {
            if (props.size == null) {
                return 0;
            }
            if (isPlainObject(props.size)) {
                var _props_size_key;
                return addUnit((_props_size_key = props.size[key]) !== null && _props_size_key !== void 0 ? _props_size_key : 0);
            }
            if (Array.isArray(props.size)) {
                var size = props.size;
                if (key === 'width') {
                    return addUnit(size[0]);
                }
                if (key === 'height') {
                    var _size_;
                    return addUnit((_size_ = size[1]) !== null && _size_ !== void 0 ? _size_ : size[0]);
                }
            }
            return addUnit(props.size);
        };
        return {
            __sfc: true,
            props: props,
            emit: emit,
            getSizeByKey: getSizeByKey
        };
    }
}));
